<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Title-->
    <div>
      <HeaderComponent :headerTitle="headerText" :router-link="{ name: 'approvalRequest' }" :router-link-text="'Approval Request'"  :return-condition="true" :component-name="item_id"/>
    </div>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-putaway" v-model="filterPopup" persistent max-width="700px">
        <v-card>
          <v-card-actions>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="user" label="User" outlined class="ma-2" style="max-width: 350px;"></v-text-field>
            <v-combobox v-model="path" :items="filter_path" item-title="name" item-value="id" label="Path" style="width: 300px !important;" outlined ></v-combobox>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small text color="normal">CANCEL</v-btn>
            <v-btn small color="primary">APPLY FILTER(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- search action and filter -->
    <v-card-title >
        <v-row>
          <v-col cols="8" sm="8">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="pending_return_search" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData()"></v-text-field>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-card-actions style="margin-bottom: 28px;">
          <v-btn variant="flat" class="ma-2" :color="this.selected.length ? '' : 'primary'" :disabled = "selected.length == 0">Re-propose</v-btn>
          <v-btn variant="flat" class="ma-2 green" :color="this.selected.length ? '' : 'primary'" :disabled = "selected.length == 0">Approve</v-btn>
          <v-btn variant="flat" class="ma-2 red" :color="this.selected.length ? '' : 'primary'" :disabled = "selected.length == 0">reject</v-btn>
        </v-card-actions>
        <!-- filter -->
        <v-expansion-panels class="custom-control_outlined" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel outlined @click="handleFilterPopup" >
          <v-expansion-panel-header>Filter
            <template v-slot:actions>
              <v-icon color="primary">
                mdi-menu-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-title>
    <!-- table content -->
    <v-layout column>
      <v-flex md6 style="overflow: auto">
        <v-card class="v-card v-card-100">
          <v-row class="ml-5">
            <v-col cols="4" sm="4" md="4" lg="4">Approval Request No:</v-col>
            <v-col cols="4" sm="4" md="4" lg="4">Requested By:</v-col>
            <v-col cols="4" sm="4" md="4" lg="4">Requested Date: </v-col>
          </v-row>
        </v-card>
        <v-data-table 
          :dense="true" 
          :search="search" 
          v-model="selected" 
          show-select
          disable-pagination 
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data" 
          :loading="loading" 
          loading-text="Loading Data... Please wait"
          class="elevation-1">
        </v-data-table>
      </v-flex>
    </v-layout>
    <div>
      <v-row class="ml-2">
        <v-col cols="2" sm="2">
          <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @update:modelValue="handlePageSizeChange" ></v-select>
        </v-col>
        <v-spacer></v-spacer>
        <span class="item-selected">
          <span v-if="selected.length == 1">{{selected.length}} Item Selected</span>
          <span v-if="selected.length > 1">{{selected.length}} Items Selected</span>
        </span>
        <v-col cols="6" sm="6">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @update:modelValue="handlePageChange" ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  export default {
    data() {
      return {
        headerText: "Pending Approval",
        alert: false,
        alert_message:'',
        alert_type:"",
        search_tag : '',
        selected: [],
        table_data : [],
        totalPages : 1,
        pageSize : 100,
        pageSizes: [50,100,200],
        page : 1,
        user : '',
        path : '',
        filter_path: [],
        search : '',
        loading: false,
        pending_return_search :'',
        headers: [
          { text: "Tag ID", value: "tag_number", align: "start", sortable: false,},
          { text: "Article ID", value: "request_id" },
          { text: "MRP (₹)", value: "name", sortable: false,},
          { text: "Article Description", value: "claim_amount" }
        ],
        filterPopup : false,
      }
    },
    components: {
      HeaderComponent
    },
    created() {
      this.item_id = this.$route.params.item_id;
      this.loadData();
    },
    methods : {
      loadData() {
        this.selected = []
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.pageSize = 100
        this.getPendingApproval();
      },
      getPendingApproval(){       
        const params = {
          "search":this.pending_return_search,
          "page": this.page,
          "per_page": this.pageSize
        };
        this.loading = true;
        this.$httpSecured
          .get("/api/v1/issue_inventories/pending_approvals", { params: params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.issue_inventories;
              this.totalPages = response.data.meta.total_pages;
              this.makeLoadingFalse()
              this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
                this.makeLoadingFalse()
              }
            }
          )
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.makeLoadingFalse()
        });
      },
      itemApproval(item){
        
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.makeLoadingFalse();
      },
      makeLoadingFalse(){
        setTimeout(() => {
          this.loading = false;
          this.alert = false;
        }, 1500);
      },
      handleFilterPopup (){
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.filterPopup =  true
      },
      handlePageSizeChange(){

      },
      handlePageChange(){

      },
    }
  }
</script>
<style>

  .v-dialog__content:has(.filter-putaway){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .green{
    background: #219653;
    color: #fff;
  }
  .red{
    background: #EC0101;
    color: #fff;
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
</style>